import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'start',
};
